module.exports = __webpack_public_path__ + "images/v1005.png?e84f95fd650b6f3bba7cdb371efc0655";


//////////////////
// WEBPACK FOOTER
// ./static/images/win/v1005.png
// module id = 485
// module chunks = 0